import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { ProductDetails } from "../../../sc-models/facility-product-details-dto";
import { FormConfigProps } from "../../../../../shared/components/form-builder/form-builder.model";
import FormBuilder from "../../../../../shared/components/form-builder/form-builder";
import { dtrackItService } from "../../../../transaction-certificates/tc-service/dtrackit.service";
import { Option } from "./component-details-form";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { useApi } from "../../../../../shared/hooks/useApi";
import { useParams } from "react-router-dom";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { useScStore } from "../../../../../store/scStandard.store";

interface ProductDetailsFormProps {
  formRef: any;
  productData: ProductDetails;
  isProductNoRequired: boolean;
  setProductData: React.Dispatch<React.SetStateAction<ProductDetails>>;
  setIsProductNoRequired: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProductDetailsForm: React.FC<ProductDetailsFormProps> = ({
  formRef,
  productData,
  setProductData,
  isProductNoRequired,
  setIsProductNoRequired,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [labelGrades, setLabelGrades] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [facilityData, setFacilityData] = useState<Option[]>([]);
  const { apiData: shipmentData, loading, error, executeGet } = useApi();
  const { SC_ID } = useParams();
  // const [isProductNoRequired, setIsProductNoRequired] = useState(true);
  const [responseData, setResponseData] = useState<any>(null);
  const [labelGradeData, setLabelGradeData] = useState<Record<string, number>>({});
  const [facilityStandardsCache, setFacilityStandardsCache] = useState<Record<string, string[]>>({});
  const { scStandards } = useScStore();
  const { setFPDPrdtCat, setFPDPrdtDtl, setFPDStdLblGrd } =
    useTransactionCertificateStore();

  const loadFacilityData = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_FACILITY_DETAILS, {
        scId: SC_ID,
      });

      console.log("Facility Details:", response.data.response);
      if (!Array.isArray(response.data.response)) {
        throw new Error("Invalid response: facilityDetails should be an array");
      }

      // Set full facility details for later usage
      setResponseData(response.data.response);

      // Map facilityNo for dropdown/select options
      const result =
        response.data.response.map((facility: any) => ({
          value: facility.facilityNo || "",
          label: facility.facilityNo || "",
        })) || [];

      setFacilityData(result);
      // Ensure associatedFacilityNo is always an array
      const facilityNo = productData?.associatedFacilityNo;
      const facilityNoArray = Array.isArray(facilityNo)
        ? facilityNo
        : facilityNo
        ? [facilityNo]
        : [];
      handleFacilityChange(facilityNoArray, response?.data?.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  const standardLabelGradeCondition = async(facilityId: string, scId: string): Promise<string[]> =>{
    try{
      const response: any = await executeGet(API_ROUTES.GET_FACILITY_DETAILS_NEW, {
          facilityId: facilityId ,
          scId: scId,
        });
        console.log(response.data?.facilityDetails[0]?.facilityStandard,"response.data?.facilityDetails[0]?.facilityStandard");
        const facilityStandard = response.data?.facilityDetails[0]?.facilityStandard;
      const uniqueFacilityStandards = Array.from(new Set(facilityStandard || []));
      return uniqueFacilityStandards as string[];
    } catch (err) {
      console.error("Failed to fetch facility standards:", err);
      return [];
    }
  }

  const updateStandardFacilityCount = async(selectedFacilityNos: string[]) => {
    const specialProcessData = responseData;
    if (!specialProcessData) return;

    const newRefCount: Record<string, number> = {};
    const newCache = { ...facilityStandardsCache };

    for (const facilityNo of selectedFacilityNos) {
      const facility = specialProcessData.find((f: any) => f.facilityNo === facilityNo);
      if (!facility) continue;

      const facilityId = facility.facilityId;
      const scId = facility.scId;

      let standards: string[];
      if (newCache[facilityId]) {
        standards = newCache[facilityId];
      } else {
        standards = await standardLabelGradeCondition(facilityId, scId);
        newCache[facilityId] = standards;
      }

      standards.forEach((standard: string) => {
        newRefCount[standard] = (newRefCount[standard] || 0) + 1;
      });
    }

    setFacilityStandardsCache(newCache);
    setLabelGradeData(newRefCount);
    console.log("Facility Standards Reference Count:", newRefCount);

    const facilityStandards = Object.keys(newRefCount);
    if (facilityStandards.length > 0) {
      await getLabelGrades(facilityStandards);
    } else {
      setLabelGrades([]);
    }
  }

const toggleDrawer = () => {
  if (drawerOpen) resetForm();
  setDrawerOpen((prev) => !prev);
};

const resetForm = () => {
  setProductData(productData);
};

  const handleFacilityChange = (value: string | string[], facilityDetailsData: any) => {
    const specialProcessData = facilityDetailsData ?? responseData;
    // Convert value to array if it's a string
    const facilityValues = Array.isArray(value) ? value : (value ? [value] : []);
    if (!facilityValues || facilityValues.length === 0) return;

    console.log("value", facilityValues);

    // Define the process codes that make product number not required
    const specialProcessCodes = [
      "PR0000",
      "PR0025",
      "PR0030",
      "PR0035",
      "PR9999",
    ];

    // Find the first facility that matches any of the selected values
    const selectedFacility = specialProcessData?.find((facility: any) =>
      facilityValues.includes(facility.facilityNo)
    );

    console.log("selectedFacility", selectedFacility);

    if (selectedFacility) {
      // Safely check if facilityProcessDetails exists
      const facilityProcessDetails =
        selectedFacility.facilityProcessDetails || [];

      // Check if there are any process codes that are NOT in specialProcessCodes
      const hasNonSpecialProcessCode = facilityProcessDetails.some(
        (process: any) =>
          !specialProcessCodes.includes(process.facilityProcessCategoryCode)
      );

      // Check if there are ONLY special process codes
      const hasOnlySpecialProcessCodes =
        facilityProcessDetails.length > 0 &&
        facilityProcessDetails.every((process: any) =>
          specialProcessCodes.includes(process.facilityProcessCategoryCode)
        );

      console.log(
        "selectedFacility.facilityType",
        selectedFacility.facilityType
      );
      setIsProductNoRequired(
        !(selectedFacility.facilityType === "CS" || hasOnlySpecialProcessCodes)
      );
    } else {
      // Default to required if no facility is selected or no process details
      setIsProductNoRequired(true);
    }

    // Update form value if needed - always ensure it's an array
    if (formRef.current) {
      formRef.current.setFieldValue("associatedFacilityNo", facilityValues);
    }
    
    updateStandardFacilityCount(facilityValues);
  };

  const getLabelGrades = async (standards?: string[]) => {
    try {
      const standardsToUse = standards && standards.length > 0 
        ? [...standards, "NA"] 
        : [...scStandards, "NA"];
      
      const result: any =
        await dtrackItService.getStandradLabelGradeOnBasisOfSelectedStandard(
          standardsToUse
        );
      // Utills.cl(`result ${JSON.stringify(result)}`)
      const lblGrades = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1}`,
      }));
      // Utills.cl(`lblGrades ${JSON.stringify(lblGrades)}`)
      setLabelGrades(lblGrades);
      setFPDStdLblGrd(lblGrades);

      // Utills.cl(`lblGrades ${lblGrades}`)
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  useEffect(() => {
    const getProductCategory = async () => {
      try {
        const result: any = await dtrackItService.getProductCategory();

        // Utills.cl(`result ${JSON.stringify(result)}`)

        const prdtCategory = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        Utills.cl(`prdtCategory ${JSON.stringify(prdtCategory)}`);
        setProductCategory(prdtCategory);
        setFPDPrdtCat(prdtCategory);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getProductDetails = async () => {
      try {
        const result: any = await dtrackItService.getProductDetailsCode();
        const prdtDetails = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        setProductDetails(prdtDetails);
        setFPDPrdtDtl(prdtDetails);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };
    getLabelGrades();
    getProductCategory();
    getProductDetails();

    if (SC_ID) loadFacilityData();
  }, []);
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        productNo: isProductNoRequired
          ? Yup.string().required("Product No. is required")
          : Yup.string(), // Optional when not required
        associatedFacilityNo: Yup.array()
          .of(Yup.string())
          .min(1, "At least one Associated Facility No. is required")
          .required("Associated Facility No. is required"),
        standardLabelGrade: Yup.array()
          .of(Yup.string())
          .min(1, "At least one Standard Label Grade is required")
          .required("Standard Label Grade is required"),
        productCategory: isProductNoRequired
          ? Yup.string().required("Product Category is required")
          : Yup.string(), // Optional when not required
        productCategoryUserSpecificTerm: Yup.string().optional(),
        productDetail: isProductNoRequired
          ? Yup.string().required("Product Detail is required")
          : Yup.string(), // Optional when not required
        productDetailUserSpecificTerm: Yup.string().optional(),
      }),
    [isProductNoRequired] // Re-create schema when isProductNoRequired changes
  );
  const formConfig: FormConfigProps = {
    pageName: "",
    initialValues: productData,
    validationSchema: validationSchema,
    sections: [
      {
        title: "Product Details",
        fields: [
          {
            label: "Product No.",
            name: "productNo",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: isProductNoRequired,
            props: { placeholder: "Enter Product No." },
          },
          {
            label: "Associated Facility No.",
            name: "associatedFacilityNo",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            events: {
              onChange: (value: string | string[]) => {
                const facilityValues = Array.isArray(value) ? value : (value ? [value] : []);
                handleFacilityChange(facilityValues, responseData);
              },
            },
            props: {
              placeholder: "Enter Associated Facility No.",
              options: facilityData,
              multiple: true,
            },
          },
          {
            label: "Standard Label Grade",
            name: "standardLabelGrade",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            props: {
              multiple: true,
              options: labelGrades,
              placeholder: "Select Standard Label Grade",
            },
          },
          {
            label: "Product Category",
            name: "productCategory",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: isProductNoRequired,
            props: {
              enableSearch: true,
              options: productCategory,
              placeholder: "Select Product Category",
            },
          },
          {
            label: "Product Detail",
            name: "productDetail",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: isProductNoRequired,
            props: {
              enableSearch: true,
              options: productDetails,
              placeholder: "Select Product Detail",
            },
          },
          {
            label: "Product Category (User Specific Term)",
            name: "productCategoryUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter User Specific Term for Product Category",
            },
          },

          {
            label: "Product Detail (User Specific Term)",
            name: "productDetailUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: "Enter User Specific Term for Product Detail",
            },
          },
        ],
      },
    ],
    handleSubmit: (values) => {
      Utills.cl("Form Submitted:", values);
      setProductData(values); // Assumes `setProductData` is defined elsewhere
      toggleDrawer(); // Assumes `toggleDrawer` is defined elsewhere
    },
  };

  return (
    <FormBuilder
      formConfig={formConfig}
      onSubmit={formConfig.handleSubmit}
      formRef={formRef}
    />
  );
};

export default ProductDetailsForm;
